export enum ETipoPlaca {
    MDFE = 1,
    RPE = 2,
    TA = 3,
    TVF = 4,
    RPA = 5
}
